import { render, staticRenderFns } from "./OutCallTask.vue?vue&type=template&id=38b8d1d2&scoped=true&"
import script from "./OutCallTask.vue?vue&type=script&lang=js&"
export * from "./OutCallTask.vue?vue&type=script&lang=js&"
import style0 from "./OutCallTask.vue?vue&type=style&index=0&id=38b8d1d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b8d1d2",
  null
  
)

export default component.exports